import styled from 'styled-components';

export const StyledForm = styled.form`
  margin-top: 70px;
`;

export const Row = styled.div`
    margin-bottom: 19px;
`;
